import type React from 'react';

import {
  tabsLabel,
  tabsSection,
  tabsTab,
} from '@mage-ui/styled-system/recipes';
import { Tabs as MantineTab } from '@mantine/core';

export type TabsTabProps = {
  classNames?: {
    tab?: string;
    tabLabel?: string;
    tabSection?: string;
  };
  children?: React.ReactNode;
  startSlot?: React.ReactNode;
  endSlot?: React.ReactNode;
  value: string;
};

export const TabsTab = ({
  classNames,
  startSlot,
  endSlot,
  children,
  ...props
}: TabsTabProps) => {
  return (
    <MantineTab.Tab
      classNames={{
        tab: classNames?.tab ?? tabsTab(),
        tabLabel: classNames?.tabLabel ?? tabsLabel(),
        tabSection: classNames?.tabSection ?? tabsSection(),
      }}
      leftSection={startSlot}
      rightSection={endSlot}
      {...props}
    >
      {children}
    </MantineTab.Tab>
  );
};

TabsTab.displayName = 'Tabs.Tab';
